import { ref } from 'vue';

// Global sidebar state - initialize collapsed on mobile, expanded on desktop
const isCollapsed = ref<boolean>(typeof window !== 'undefined' ? window.innerWidth < 992 : false);
const isMobile = ref<boolean>(typeof window !== 'undefined' ? window.innerWidth < 992 : false);

const useSidebar = () => {
  const toggleSidebar = () => {
    isCollapsed.value = !isCollapsed.value;
  };

  const collapseSidebar = () => {
    isCollapsed.value = true;
  };

  const expandSidebar = () => {
    isCollapsed.value = false;
  };

  const setMobile = (mobile: boolean) => {
    isMobile.value = mobile;
    if (mobile) {
      isCollapsed.value = true;
    }
  };

  return {
    collapseSidebar,
    expandSidebar,
    isCollapsed,
    isMobile,
    setMobile,
    toggleSidebar,
  };
};

export default useSidebar;
